<template>
  <div v-if="items && items.length > 0">
    <!-- Header for items to purchase -->
    <h2 class="text-normal-emphasis font-bold mb-2">Other Items</h2>

    <div class="mb-6">
      <template v-for="(item, index) in items" :key="item.item.itemId">
        <!-- Standard Hand -->
        <LineItemControl v-if="item.item.itemType === Constants.CUSTOM_TYPE" :item="item.item" v-model="item.count"
          :quantity-options="registrationOptions" :name="`registration-${index}`"
          :show-quantity-selector="item.count > 1" />
        <LineItemDonateControl v-else :item="item.item" v-model="item.item.amount" />

      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import Constants from "@/models/Constants";
import { Item } from "@models/Item";
import { PokerRunEvent } from "@models/PokerRunEvent";
import { computed, ref, watch } from "vue";
import { SelectOption } from '@/models/SelectOption';
import LineItemControl from "@/components/LineItemControl.vue";
import LineItemDonateControl from "@/components/LineItemDonateControl.vue";

interface SelectedItem {
  item: Item;
  count: number;
}

interface Props {
  pokerRun: PokerRunEvent | undefined;
}

const props = defineProps<Props>();
const emit = defineEmits(['update:selectedItems']);

const registrationOptions: SelectOption[] = Array.from({ length: 99 }, (_, index) => ({
  id: index,
  name: index.toString()
}));

const items = ref<SelectedItem[]>([]);


const initializeItems = () => {
  if (!props.pokerRun) return;

  const customItems = props.pokerRun.lineItems
    .filter(x => x.itemType === Constants.CUSTOM_TYPE || x.itemType === Constants.DONATION_TYPE)
    .sort((a, b) => {
      // Sort by itemType first
      if (a.itemType !== b.itemType) {
        return a.itemType.localeCompare(b.itemType);
      }
      // If itemType is the same, sort by name/description
      return (a.name || '').localeCompare(b.name || '');
    });

  items.value = customItems.map(item => ({
    item,
    count: 0,
  }));
};

watch(() => props.pokerRun, (newVal) => {
  if (newVal) {
    initializeItems();
  }
}, { immediate: true });

watch(() => items.value, (newVal) => {
  const donationItem = newVal.find(x => x.item.itemType === Constants.DONATION_TYPE);
  if (donationItem) {
    if (donationItem?.item.amount > 0) {
      donationItem.count = 1;
    } else {
      donationItem.count = 0;
    }
  }
  emit('update:selectedItems', newVal);
}, { deep: true });
</script>
